/* eslint-disable camelcase */
export default {
	cancel: '取消',
	definite: '确定',
	prompt: '提示',
	confirm_deletion: '单据删除后将不能恢复，是否确认删除?',
	home_page: '首页',
	order_management: '订单管理',
	order_Name: '订单名称',
	package_agreement_change: '一揽子协议变更',
	package_agreement_entry: '一揽子协议录入',
	delete: '删除',
	save: '保存',
	submit: '提交',
	draft: '草稿',
	in_the_draft: '草稿中',
	confirm: '确认',
	confirm_s: '确定',
	support_agreement: '关联合同禁止选择补充协议',
	draft_deleted_successfully: '草稿删除成功',
	deleted: '已删除',
	deleted_successfully: '删除成功',
	do_you_want_to_use_the_latest_price: ',是否使用最新价格?',
	use_the_latest_price: '使用最新价格',
	use_current_price: '使用当前价格',
	the_current_quoted_price_of_has_expired: '的当前引用价格已失效，是否继续',
	there_is_no_price_library_quotationo_refresh_the_price: '没有价格库报价，是否刷新价格库',
	the_material_code_is: '物料编码为 ',
	no_price_library_quotation: ' 没有价格库报价',
	draft_saved_successfully: '保存草稿成功',
	the_application_form_has_been_submitted_successfully: '申请单提交成功，申请单号：',
	the_package_agreement_has_been_changed_successfully: '一揽子协议变更成功，申请单号：',
	is_it_refreshed_if_the_order_detail_price_is_inconsistent_with_the_price_base_price: '订单明细价格与价格库价格不一致 是否刷新?',
	get_the_latest_quotation_successfully: '获取最新报价成功',
	in_the_change_information_the_change_description_and_payment_terms_cannot_be_empty: '变更信息中，变更说明、付款条件不能为空',
	in_the_basic_information_our_subjecter_required_information_cannot_be_empty: '基础信息中，我方主体、供应商、供应商收单邮箱等必填信息不能为空',
	package_agreement_change_browsing: '一揽子协议变更浏览',
	package_agreement_browsing: '一揽子协议浏览',
	withdraw: '撤回',
	examination_and_approval: '审批',
	examination_and_approval_opinions: '审批意见',
	please_enter_approval_opinions_rejection_must_be_entered: '请输入审批意见，驳回必须输入',
	i_agree: '同意',
	transfer: '转交',
	rejected: '驳回',
	please_select_the_transferor: '请选择转交人',
	transfer_to: '转给：',
	please_select: '请选择',
	operation: '操作',
	initiate_a_change: '发起变更',
	terminate_an_order: '终止订单',
	distribution_has_been_completed: '已完成发放',
	approval_successful: '审批成功',
	approval_opinions_must_be_entered_for_rejection: '驳回必须输入审批意见',
	approval_rejected_successfully: '审批驳回成功',
	the_current_approver_cannot_be_consistent_with_the_transferor: '当前审批人不能和转交人一致',
	successful_transfer_of_examination_and_approval: '审批转交成功',
	at_presentter_termination_it_will_no_longer_be_able_to: '当前有未发放的数量，终止后将不能再进行发放及影响验收，是否确认终止？',
	after_the_termination_it_will_not_be_issued_do_you_want_to_confirm_the_termination: '终止后将不能再进行发放，是否确认终止',
	order_terminated_successfully: '成功终止订单',
	package_order_browsing: '一揽子订单浏览',
	basic_information: '基本信息',
	rmb: '人民币',
	countersigned: '已回签',
	waiting_to_be_countersigned: '待回签',
	not_issued: '未发出',
	associated_contract: '关联合同',
	order_type: '订单类型',
	standard_order: '标准订单',
	package_order: '一揽子订单',
	order_maker: '制单人',
	issue_details: '发放明细',
	total_amount_paid: '发放总金额：',
	amount_paid: '已付款金额：',
	no_data_available_for_the_time_being: '暂无数据',
	serial_number: '序号',
	package_quantity: '一揽子数量',
	issued: '已发放',
	this_quantity: '本次数量',
	purchase_unit_price: '采购单价',
	subtotal_amount: '小计金额',
	receiving_warehouse_computer_room: '收货仓库/机房',
	delivery_address: '送货地址',
	remarks: '备注',
	received_goods: '已收货',
	value_added_tax_code: '增值税码',
	price_excluding_tax: '不含税价格',
	contract_information: '合同信息',
	details_of_requirements: '需求明细',
	demand_location: '需求地点',
	quantity: '数量',
	expected_delivery_time: '期望货期',
	application_department: '申请部门',
	user: '使用人',
	distribution_table: '配送表',
	export_detail: '导出明细',
	product_name: '品名',
	brand: '品牌',
	model: '型号',
	fixed_capital_number: '固资号',
	sn_code: 'SN码',
	transport_management_detail_id: '运管明细ID',
	hardware_configuration: '硬件配置',
	raid_typ: 'Raid类型',
	rack: '机架',
	machine_position: '机位',
	expected_date_of_arrival: '预计到货日期',
	actual_arrival_date: '实际到货日期',
	delay_advance_reason: '延期/提前原因',
	attachment_information: '附件信息',
	there_is_no_data_in_the_distribution_table_for_the_time_being: '配送表暂无数据',
	it_may_take_a_long_time_to_export_please_wait: '导出可能需要较长时间，请等待。（不要关闭页面或重复点击导出按钮）',
	handled_successfully: '处理成功',
	standard_order_browsing: '标准订单浏览',
	order_number: '订单编号',
	status: '订单状态',
	our_main_body: '我方主体',
	supplier: '供应商',
	supplier_receipt_mailbox: '供应商收单邮箱',
	currency: '币种',
	countersign_status: '回签状态',
	related_contract: '关联合同',
	terms_of_payment: '付款条件',
	manager: '经办人',
	relevant_approver: '相关审批人',
	Optionalmaterialcategory: '可选物料类别',
	special_label: '专项标签',
	order_typ: '订单类型',
	make_a_single_person: '制单人',
	date_of_order_making: '制单日期',
	acceptance_completion_date: '验收完成日期',
	due_date: '应付日期',
	purchase_instructions: '采购说明',
	order_details: '订单明细',
	total_order_amount: '订单总金额：',
	price_library_quotation: '价格库报价',
	maximum_purchase_quantity: '最高采购量',
	amount_executed: '已执行量',
	approval_information: '审批信息',
	standard_order_change_browsing: '标准订单变更浏览',
	package_order_change_browsing: '一揽子订单变更浏览',
	change_information: '变更信息',
	change_order_number: '变更单号',
	change_description: '变更说明',
	supplier_collection_account_number: '供应商收款账号',
	whether_payment_is_planned_or_not: '是否计划付款',
	yes: '是',
	no: '否',
	package_agreement: '一揽子协议',
	national_area: '国家地区',
	change_details: '变更明细',
	new_quantity: '新数量',
	original_purchase_unit_price: '原采购单价',
	new_purchase_unit_price: '新采购单价',
	original_delivery_date: '原送货日期',
	new_delivery_date: '新送货日期',
	original_receiving_warehouse_computer_room: '原收货仓库/机房',
	new_receiving_warehouse_computer_room: '新收货仓库/机房',
	original_gift_consignee: '原赠品收货人',
	new_gift_consignee: '新赠品收货人',
	please_enter: '请输入',
	transfer_successful: '转交成功',
	order_change_query: '订单变更查询',
	query_condition: '查询条件',
	date_of_change: '变更日期',
	to: '至',
	start_date: '开始日期',
	end_date: '结束日期',
	query: '查询',
	query_result: '查询结果',
	done: '已办',
	my_draft: '我的草稿',
	material_category: '物料类别',
	item_name: '物料名称',
	abstract_type: '抽象类型',
	export: '导出',
	purchase_amount: '采购金额',
	advanced_search: '高级搜索',
	general_search: '普通搜索',
	order_query: '订单查询',
	buyer: '采购员',
	order_status: '订单状态',
	payment_status: '付款状态',
	all: '全部',
	custom_display_field: '自定义显示栏位',
	export_order_details: '导出订单明细',
	enter_a_package_of_agreements: '录入一揽子协议',
	accepted_amount: '已验收金额',
	effective: '已生效',
	effective_over: '已完成',
	paid: '已付款',
	payment_in_progress: '付款中',
	pending_payment: '待付款',
	payment: '付款',
	waiting_for_acceptance: '待验收',
	terminated: '已终止',
	checked_and_accepted: '已验收',
	order_view: '订单视图',
	demand_quantity: '需求数量',
	the_current_list_has_no_data_and_cannot_be_exported: '当前列表无数据，无法导出',
	please_enter_keywords: '请输入关键词',
	please_enter_a_keyword: '请输入关键字',
	team_leader: '小组负责人',
	the_person_in_charge_of_the_center: '中心负责人',
	early_warning_category: '预警类别',
	export_data: '导出数据',
	batch_attention: '批量关注',
	batch_does_not_pay_attention_to: '批量不关注',
	approval_completion_time: '审批完成时间',
	expiration_time_buyer: '到期时间(采购员)',
	expiration_time_team_leader: '到期时间(小组负责人)',
	expiration_time_head_of_the_centre: '到期时间(中心负责人)',
	current_warning_level: '目前预警级别',
	remove: '移除',
	no_early_warning: '未预警',
	order_warning: '订单预警-',
	batch_attention_is_successful: '批量关注成功',
	batch_does_not_focus_on_success: '批量不关注成功',
	change_of_package_order: '一揽子订单变更',
	change_description_cannot_be_empty: '变更说明不能为空',
	please_enter_the_quantity: '请输入数量',
	please_select_a_delivery_date: '请选择送货日期',
	please_select_the_warehouse_computer_room: '请选择仓库机房',
	please_enter_the_shipping_address: '请输入送货地址',
	please_enter_the_consignee: '请输入收货人',
	cannot_be_greater_than_the_original_quantity: '不能大于原数量',
	cannot_be_less_than_the_quantity_received: '不能小于已收货数量',
	the_new_quantity_cannot_be_greater_than_the_original_quantity_and_cannot_be_less_than_the_received_quantity:
		'新数量不能大于原数量 不能小于已收货数量',
	package_order_entry: '一揽子订单录入',
	add_a_giveaway: '添加赠品',
	please_enter_a_number: '请输入数字',
	gift_consignee: '赠品收货人',
	split: '拆分',
	issue_details_to_split: '发放明细拆分',
	material_code: '物料编码',
	original_quantity: '原数量',
	material_description: '物料描述',
	package_agreement_giveaway: '一揽子协议赠品',
	the_quantity_must_be_greater_than_0: '数量须大于0',
	cannot_be_greater_than_the_quantity_accepted: '不能大于受理数量',
	material: '物料',
	the_quantity_of_this_release_of_material_distributed_by_the_package_agreement: '的本次发放数量超过了一揽子协议可发放的数量，是否仍然继续？',
	please_fill_in_the_required_items: '请填写必填项',
	submitted_successfully: '提交成功',
	the_sum_of_the_split_quantity_cannot_be_greater_than_the_original_quantity: '拆分数量之合不能大于原数量',
	split_quantity_cannot_be_equal_to: '拆分数量不能等于0',
	split_data_delivery_date_delivery_address_can_not_be_the_same_receiving_warehouse_computer_room_can_not_be_the_same:
		'拆分数据送货日期、送货地址不能相同、收货仓库/机房不能相同',
	choose_at_least_one: '至少要选择一条',
	cancel_unsigned_reminder: '取消未回签提醒',
	reissue_the_order: '重新发出订单',
	download_english_pdf: '下载英文PDF',
	download_pdf: '下载PDF',
	export_asset_number: '导出资产号',
	whether_payment_is_planned: '是否计划付款',
	country_and_region: '国家地区',
	payment_information: '付款信息',
	payment_order_number: '付款单号',
	amount: '金额',
	date_of_payment: '付款日期',
	invoice_information: '发票信息',
	invoice_number: '发票号码',
	invoice_code: '发票代码',
	invoice_type: '发票类型',
	unknown_type: '未知类型',
	special_invoice_for_value_added_tax: '增值税专用发票',
	vat_general_invoice: '增值税普通发票',
	invoice_date: '开票日期',
	source_order_number: '来源单号',
	invoice_amount: '发票金额',
	invoice_currency: '发票币种',
	invoice_tax: '发票税金',
	remaining_invoice: '剩余发票',
	associated_amount: '关联金额',
	related_tax: '关联税金',
	current_remaining_amount: '当前剩余金额',
	certification_deduction: '认证抵扣',
	the_order_is_from_synchronize_to_erp_please_try_again_later: '订单正在同步到ERP，请稍后再试...',
	order_export_asset_number: '订单导出资产号',
	pending_approval: '待审批',
	order_date: '订货日期',
	export_result: '导出结果',
	selected_consent: '所选同意',
	selected_rejected: '所选驳回',
	selected_transfer: '所选转交',
	order_change: '订单变更',
	standard_order_change: '标准订单变更',
	to_be_done: '待办',
	system_processing: '系统处理中',
	approval_by_relevant_approvers: '相关审批人审批',
	aborted: '已中止',
	order_list: '订单列表-',
	please_check_the_data: '请勾选数据',
	demand_order_number: '需求单号',
	failed_to_process_errormessage: '】处理失败；ErrorMessage：',
	processing_failed: '处理失败',
	transfer_failed_errormessage: '】转交失败；ErrorMessage：',
	transfer_failed: '转交失败',
	please_select_terms_of_payment: '请选择付款条件',
	saved_successfully: '保存成功',
	it_cannot_be_restored_after_deletion_do_you_want_to_continue: '删除后不能恢复, 是否继续?',
	standard_order_entry: '标准订单录入',
	this_operation_cannot_be_resumed_do_you_want_to_continue: '此操作不能恢复, 是否继续?',
	the_same_delivery_date_computer_room_and_delivery_address_of_the_same_material_cannot_be_submitted:
		'相同物料的送货日期、机房、送货地址相同不能提交',
	order_detail_line_non_freebies_at_leastline: '订单明细行非赠品至少1行',
	current_handler: '当前处理人',
	handlers: '处理人',
	post: '岗位',
	processing_steps: '处理步骤',
	opinions: '意见',
	processing_time: '处理时间',
	time_consuming: '耗时',
	hand_over_to: '转交给',
	hour: '小时',
	points: '分',
	upload_attachment: '上传附件',
	download: '下载',
	input_person: '录入人',
	business_reasons: '业务事由',
	the_detailed_list_is_all_gifts: '明细列表全为赠品',
	exchange_rate: '汇率',
	foreign_suppliers_and_foreign_currencies_usually_do_not_have_value_added_tax__please_check_with_the_financial_staff_before_choosing:
		'境外供应商、外币通常没有增值税（VAT0），请先和财务人员确认再选择',
	please_select_a_supplier_first: '请先选择供应商',
	please_select_our_main_body: '请选择我方主体',
	please_select_a_supplier: '请选择供应商',
	please_select_the_supplier_to_send_the_account_number_automatically: '请选择供货商自动发出账号',
	please_select_a_currency: '请选择币种',
	please_select_an_associated_contract: '请选择关联合同',
	please_choose_an_agent: '请选择经办人',
	please_enter_the_purchase_description: '请输入采购说明',
	please_select_a_country_or_region: '请选择国家地区',
	submission_processing: '提交处理中',
	the_contract_does_not_exist: '该合同不存在',
	the_detail_list_cannot_be_empty: '明细列表不能为空',
	when_choosing_a_related_contract_we_must_first_select_our_main_body_and_supplier: '选择关联合同时必须先选择我方主体和供应商',
	please_enter_a_description_of_the_change: '请输入变更说明',
	amount_shipped: '已发运金额',
	add_material: '添加物料',
	unit_price_excluding_tax: '不含税单价',
	other_prices: '其他价格',
	price_library_query: '价格库查询',
	quotation_number: '报价单号',
	please_enter_the_quotation_number: '请输入报价单号',
	effective_date: '生效日期',
	expiration_date: '失效日期',
	choice: '选择',
	internal_model: '内部型号',
	quotation: '报价',
	validity: '有效性',
	input_time: '录入时间',
	please_add_materials_or_gifts_to_the_order_after_selecting_the_agent: '请在选择经办人后，再添加物料或赠品到订单中',
	please_select_a_supplier_account_before_adding_materials: '请选择供应商账号后再添加物料',
	did_not_get_the_price_library_maximum_purchase_quantity_and_other_data_from_the_price: '未从价格库获取到价格库报价、最高采购量等数据，物料编码：',
	total_amount_of_order_including_tax: '订单含税总金额',
	the_order_does_not_include_the_total_amount_of_tax: '订单不含税总金额',
	order_tax: '订单税额',
	the_item_already_exists_in_the_order_details: '订单明细中已存在该物料,[',
	in_the_order_details_there_must_be_at_least_1_line_of_non_freebies: '订单明细中，非赠品至少要有1行',
	vat_code_cannot_be_empty_in_order_details: '订单明细中，增值税码不能为空',
	source: '来源',
	manual_input: '手工录入',
	the_price_base_is_valid: '价格库有效',
	please_fill_in_the_approval_comments: '请填写审批意见',
	use: '用途',
	automatically_displayed_according_to_the_currently_selected_field: '注意：保存后下次进入页面将自动根据当前所选栏位展示.',
	countersign_the_attachment: '回签附件',
	contract_number: '合同编号',
	input_by: '录入人',
	handling_department: '经办部门',
	validity_period: '有效期',
	contract_title: '合同标题',
	business_subject_matter: '业务事由',
	delivery_date: '送货日期',
	please_enter_vat_code: '请输入增值税码',
	order_detail_split: '订单明细拆分',
	quantity_cannot_be_0: '数量不能为0',
	failed_to_get_the_latest_quotation_of_the_price_library_unable_to_jump_to_the_price_library_details_page:
		'未获取价格库最新报价、无法跳转价格库详情页面',
	split_quantity_cannot_be_0: '拆分数量不能为0',
	material_search: '物料搜索',
	confirm_the: '确认',
	not_now: '现在不选',
	enter_keywords_separated_by_spaces: '输入关键字 用空格隔开',
	search: '搜索',
	standard_delivery_time: '标准货期',
	day: '天',
	add_to_the_list: '加入清单',
	currently_selected_bom: '当前选择物料清单',
	empty: '清空',
	open_up: '开放',
	purchase_only: '仅采购',
	the_material_has_been_added: '该物料已加入',
	please_enter_currency: '请输入币种',
	please_enter_terms_of_payment: '请输入付款条件',
	please_select_a_collection_account: '请选择收款账号',
	please_enter_the_content: '请输入内容',
	please_enter_our_main_body: '请输入我方主体',
	please_enter_a_supplier: '请输入供应商',
	please_enter_the_associated_contract: '请输入关联合同',
	please_enter_the_manager: '请输入经办人',
	please_enter_the_supplier_account_number: '请输入供应商账号',
	purchase_instructions_cannot_be_empty: '采购说明不能为空',
	please_select_the_purchase_location: '请选择采购地点',
	please_select_our_main_body_and_supplier_first: '请先选择我方主体和供应商',
	exchange_rate_information_is_not_maintained: '汇率信息未维护',
	vendor_back_sign: '供应商回签',
	accept_the_precautions: '我司已接受该订单并充分了解腾讯公司订单回签的注意事项，本次上传的文件已经加盖公章/授权人签字。',
	feedback: '反馈',
	delivery_time_feedback: '货期反馈',
	import: '导入',
	line_number: '行号',
	shipping_address: '收货地址',
	order_amount: '订货数量',
	delivery_form_feedback: '配送表反馈',
	reasons_for_postponement_or_advance: '延期或提前原因',
	buyer_s: '买方',
	order_date_s: '订单日期',
	sign_back: '回签',
	select_date: '选择日期',
	order_information_pdf: '订单信息PDF',
	order_exception: '订单异常',
	unknown_order_type: '未知的订单类型',
	imported_successfully: '导入成功',
	please_check_tencent_notes: '请先阅读并勾选腾讯公司订单回签的注意事项！',
	please_upload_back_sign_attachment: '请上传回签附件！',
	choose_a_contract: '选择合同',
	my_main_body: '我方主体',
	contract_no: '合同编号',
	contract_name: '合同名称',
	search_result: '查询结果',
	sign_the_subject: '签订主体',
	center: '中心',
	country_region: '国家地区',
	order_currency: '订单币种',
	tax_amount: '含税金额',
	pay_currency: '支付币种',
	order_description: '订单说明',
	exchange_rate_type: '汇率类型',
	exchange_rate_date: '汇率日期',
	supplier_collection_mailbox: '供应商收单邮箱',
	receipt_address: '收单地址',
	pay_settlement_information: '款项结算信息',
	supplier_account: '供应商账号',
	way_of_payment: '款项结算方式',
	type_nature: '款项性质',
	payments: '款项履约金额',
	payment_amount: '款项支付金额',
	credit_credits: '款项信用期起算口径',
	credit_period_natural_day: '款项信用期（自然日）',
	cheerful_payment_date: '最迟付款日期',
	invoice_agreement: '开票约定',
	type_of_invoice: '款项发票类型',
	edit: '编辑',
	third_party_main_body: '第三方主体',
	associated_decision_making_order_number: '关联决策单号',
	associated_with_information: '关联合同信息',
	valid_date: '有效日期',
	fulfill_the_currency: '履约币种',
	business_event: '业务事由',
	association_requirements: '关联需求信息',
	demand_single_number: '需求单编号',
	applicant: '申请人',
	unit: '单位',
	unit_price: '单价',
	purchasing_detailed_information: '采购明细信息',
	total_amount: '总金额',
	tax_price: '含税单价',
	exchange_rate_quotation_currency_trading_currency: '汇率：报价币种-交易币种',
	tax_rate: '税率',
	taxCode: '税码',
	free_tax_price: '不含税单价',
	containing_tax_amount: '不含税金额小计',
	tax: '税额',
	tax_a_amount: '含税金额小计',
	expectation_period: '期望货期',
	commitment_period: '承诺货期',
	cost_center: '成本中心',
	product: '产品',
	productName: '产品名称',
	budget_date: '预算日期',
	project_number: '立项编号',
	receive_tolerance: '接收允差',
	supreme_purchase: '最高采购量',
	executed: '已执行量',
	purchase_type: '采购类型',
	whether_a_gift: '是否赠品',
	acceptance_completion: '验收完成',
	note: '备注',
	document_is_saved: '单据保存成功',
	order_is_agree: '单据审批成功',
	order_is_reject: '单据驳回成功',
	order_is_over: '单据转交成功',
	comment_success: '评论成功',
	whether_confirming_submission: '是否确认提交',
	the_document_is_submitted_successfully: '单据提交成功！',
	do_you_confirm_withdraw: '是否确认撤回',
	purchase_orders_have_been_approved_nodes_not_allowing_withdrawal: '采购订单已存在有审批节点，不允许撤回！',
	single_according_to_success: '单据撤回成功！',
	after_the_document_is_deleted_it_will_not_be_recovered_do_you_confirm_deletion: '单据删除后将不能恢复，是否确认删除',
	document_deletion_success: '单据删除成功',
	the_document_will_not_be_recovered_after_the_document_is_invalid_whether_it_is_confirmed: '单据作废后将不能恢复，是否确认作废',
	the_purchase_order_has_been_accepted_and_it_is_not_allowed: '采购订单已存在验收，不允许作废',
	document_is_successful: '单据作废成功',
	add: '增加',
	add_a_gift: '添加赠品',
	pay_details: '款项明细信息',
	credit_period: '信用期起算口径',
	credit_period_days: '信用期天数',
	add_purchase_detail: '添加采购明细信息',
	material_coding: '物料编码',
	material_name: '物料名称',
	price_library_offer: '价格库报价',
	exchange_rate_quotation_currency_trading_coin: '汇率：报价币种-交易币种',
	add_procurement: '添加采购明细',
	purchase_order_detail_information_split: '采购订单明细信息拆分',
	the_sum_of_the_splits_is_not_allowed_to_be_greater_than_the_stock: '拆分数量之和不允许大于原数量',
	delivery_branch_delivery_date_warehouse_computer_room_address_cannot_be_the_same: '拆分行送货日期、仓库/机房、地址不能相同',
	query_conditions: '查询条件',
	// order_number: '订单编号',
	// supplier: '供应商',
	// manager: '经办人',
	associated_part: '关联合同编号',
	// status: '状态',
	historic_version: '历史版本',
	// my_main_body: '我方主体',
	founder: '创建人',
	create_time: '创建时间',
	// order_type: '订单类型',
	associated_demand_single_number: '关联需求单号',
	// payment_status: '付款状态',
	// material_category: '物料类别'
	// material_coding: '物料编码',
	item_description: '物料描述',
	// order_currency: '订单币种',
	// pay_currency: '支付币种',
	whether_planning_payment: '是否计划付款',
	// country_region: '国家地区',
	departmental_department: '经办部门',
	group_name: '经办小组',
	cc_name: '经办中心',
	// custom_display_field: '自定义显示栏位',
	collaborative_status_assignment: '协同状态-分配',
	collaborative_status_confirmation: '协同状态-确认',
	// acceptance_completion_date: '验收完成日期',
	// brand: '品牌',
	// model: '型号',
	// abstract_type: '抽象类型',
	// special_label: '专项标签',
	reply: '回签状态',
	odm_oem: 'ODM/OEM',
	advanced_query_conditions: '高级搜索',
	create_date: '创建日期',
	inclusion_amount: '不含税金额',
	version: '版本',
	intention: '意向供应商',
	expected_delivery: '预计交期',
	feed_back: '问题反馈',
	whether_an_automatic_order: '是否自动订单',
	idc: 'IDC',
	note_after_saving_the_next_time_you_enter_the_page_will_be_automatically_displayed_according_to_the_current_selection_field:
		'注意：保存后下次进入页面将自动根据当前选择栏位展示。',
	please_select_the_data_that_you_need_to_do: '请选择需要执行操作的数据',
	select_up_to: '最多选择10条',
	selected_dismissal: '所选驳回',
	please_select_a_transferee: '请选择转交人',
	// transfer_to: '转交至',
	turnover: '转交说明',
	save_tracking: '保存跟踪',
	personnel: '人员',
	track_attention: '跟踪关注',
	attention: '关注',
	no_longer_pay_attention: '不再关注',
	the_amount_of_the_contract: '合同金额',
	grade: '需求等级',
	post_name: '岗位',
	executor: '执行人',
	executive_contact_information: '联系方式',
	the_default_is_empty: '默认为空',
	// user: '用户',
	firm: '公司',
	on_the_spot: '即期',
	there_is_a_contract_order: '有合同订单',
	no_contract_orders: '无合同订单',
	illustrate: '说明',
	transmitter: '转交人',
	invite: '邀请',
	IntendedSupplier: '意向供应商',
	rejectedReason: '驳回原因',
	forward_to: '转交至',
	approvalComments: '评论',
	purPoseName: '需求用途',
	requireCode: '需求编号',
	commentsPurchase: '请输入评论内容',
	TemplateDescription: '模板描述',
	Whethertoenable: '是否启用',
	Placeofpurchase: '采购地点',
	summary: '摘要',
	summary_approval_status: '摘要审批状态',
	abstract_date: '摘要日期',
	include_order_date: '包含订单订货日期',
	include_order_number: '包含订单编号',
	include_our_subject: '包含我方主体',
	include_supplier: '包含供应商',
	number_of_order: '订单数',
	summary_information: '摘要信息',
	summarize_the_purchase_amount: '汇总采购金额',
	approval_status: '审批状态',
	summary_order_list: '订单清单',
	generate_summary: '生成订单汇总摘要',
	not_transferable_to_the_current_processor: '不可转交给当前处理人',
	please_input_turnover: '请输入转交说明',
	please_input_rejected: '驳回必须输入意见',
	please_enter_required: '请输入必填内容',
	clickCopy: '点击复制',
	CopySuccess: '复制成功',
	CopyFail: '复制失败',
	summaryId: '摘要单号',
	custom_search: '自定义搜索',
	recently_used: '最近常用',
	order: '订单',
	look_more: '查看更多',
	consulting_feedback: '咨询反馈',
	operation_manual: '操作手册',
	internet_operation_manual: '网络协同操作手册',
	procurement_system_user_manual: '采购系统《系统使用手册》',
	personal_work: '个人工作台',
	pending_approval_documents: '待审批单据',
	other_pending_approval: '其他待办',
	quick_entry: '快捷入口',
	add_quick_entry: '添加快捷入口',
	my_frequently_used_functions: '我的常用功能',
	query_entry: '查询入口',
	create_entry: '创建入口',
	draft_entry: '草稿入口',
	require_name: '需求名称',
	bidded_proposal_num: '中标方案书编号',

	// 税务台账待办
	to_do_status: '待办状态'
};
